import React from 'react';
import { Switch, Checkbox } from '@progress/kendo-react-inputs';
import { Card, CardBody, CardTitle } from '@progress/kendo-react-layout';
import './index.scss';

const PublishWorkspacePanel = ({
    isPublished,
    isValidForm,
    publishHint,
    onPublishChange,
    workspaces,
    selectedWorkspaces,
    onWorkspacesChange,
    showSkillsError,
    skillsErrorMessage,
    publishLabel,
    workspaceLabel
}) => {
    const handleWorkspaceToggle = (workspaceId, checked) => {
        let newSelectedWorkspaces;
        if (checked) {
            newSelectedWorkspaces = [...(selectedWorkspaces || []), workspaceId];
        } else {
            newSelectedWorkspaces = (selectedWorkspaces || []).filter(id => id !== workspaceId);
        }
        onWorkspacesChange(newSelectedWorkspaces);
    };

    const isWorkspaceSelected = (workspaceId) => {
        return selectedWorkspaces && selectedWorkspaces.includes(workspaceId);
    };

    return (
        <div className="publish-workspace-panel">
            <div className="publish-section">
                <div className="publish-toggle-row">
                    <label className="publish-label">{publishLabel}</label>
                    <Switch
                        checked={isPublished}
                        disabled={!isPublished && !isValidForm}
                        onChange={(event) => onPublishChange(event.value)}
                    />
                </div>
                {publishHint && (
                    <div className="publish-hint">{publishHint}</div>
                )}
                {showSkillsError && skillsErrorMessage && (
                    <div className="skills-error">{skillsErrorMessage}</div>
                )}
            </div>

            <Card className="workspace-section">
                <CardBody>
                    <CardTitle className="workspace-title">                      
                        {workspaceLabel}
                    </CardTitle>
                    <div className="workspace-list">
                        {workspaces && workspaces.map((workspace) => (
                            <div key={workspace.id} className="workspace-item">
                                <Checkbox
                                    id={`workspace-${workspace.id}`}
                                    checked={isWorkspaceSelected(workspace.id)}
                                    label={workspace.nameHe || workspace.name}
                                    onChange={(event) => handleWorkspaceToggle(workspace.id, event.value)}
                                />
                            </div>
                        ))}
                    </div>
                </CardBody>
            </Card>
        </div>
    );
};

export default PublishWorkspacePanel;
